import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../sections/Footer/Footer';
import Services from '../sections/Services/Services';
import SEO from '../components/SEO';

const ServicesPage = ({ lang = 'en' }) => {
  const BASE_URL = "https://alsaketdental.com";
  const SITE_NAME = "AlSaket Dental Clinics";
  const SITE_NAME_AR = "عيادات الساكت لطب الأسنان";

  const isArabic = lang === 'ar';
  const pageUrl = `${BASE_URL}/${lang}/services`;

  // JSON-LD: Services Page
  const servicesPageLD = {
    "@context": "https://schema.org",
    "@type": "MedicalBusiness",
    "name": "AlSaket Dental Clinics Services",
    "alternateName": "خدمات عيادات الساكت لطب الأسنان",
    "url": pageUrl,
    "description": "Comprehensive dental services including orthodontics, implants, whitening, root canal treatment, and gum cleaning in Amman, Jordan.",
    "description_ar": "خدمات طب الأسنان الشاملة تشمل تقويم الأسنان، الزراعة، التبييض، علاج العصب، وتنظيف اللثة في عمان، الأردن.",
    "service": [
      {
        "@type": "MedicalProcedure",
        "name": "Orthodontic Treatment",
        "name_ar": "علاج تقويم الأسنان",
        "description": "Professional orthodontic treatment to straighten teeth and improve bite alignment."
      },
      {
        "@type": "MedicalProcedure", 
        "name": "Dental Implants",
        "name_ar": "زراعة الأسنان",
        "description": "Swiss Straumann dental implants with internet crowns and dental fillings."
      },
      {
        "@type": "MedicalProcedure",
        "name": "Teeth Whitening", 
        "name_ar": "تبييض الأسنان",
        "description": "Professional teeth whitening using home and laser whitening with latest international materials."
      },
      {
        "@type": "MedicalProcedure",
        "name": "Gum Cleaning",
        "name_ar": "تنظيف اللثة", 
        "description": "Professional gum cleaning using rotary devices and advanced techniques."
      },
      {
        "@type": "MedicalProcedure",
        "name": "Root Canal Treatment",
        "name_ar": "علاج العصب",
        "description": "Advanced root canal treatment using rotary devices and latest disinfection technology."
      }
    ]
  };

  return (
    <>
      <SEO
        title="Dental Services - AlSaket Dental Clinics"
        titleAr="خدمات طب الأسنان - عيادات الساكت"
        description="Comprehensive dental services in Amman, Jordan. Professional orthodontics, implants, whitening, root canal treatment, and gum cleaning with experienced specialists."
        descriptionAr="خدمات طب الأسنان الشاملة في عمان، الأردن. تقويم الأسنان المهني، الزراعة، التبييض، علاج العصب، وتنظيف اللثة مع أطباء متخصصين."
        keywords={[
          "dental services amman", 
          "orthodontics jordan", 
          "dental implants amman", 
          "teeth whitening amman", 
          "root canal treatment amman",
          "gum cleaning amman",
          "dental procedures jordan",
          "professional dental care amman"
        ]}
        keywordsAr={[
          "خدمات طب الأسنان عمان", 
          "تقويم الأسنان الأردن", 
          "زراعة الأسنان عمان", 
          "تبييض الأسنان عمان", 
          "علاج العصب عمان",
          "تنظيف اللثة عمان",
          "إجراءات طب الأسنان الأردن",
          "رعاية أسنان مهنية عمان"
        ]}
        url={pageUrl}
        image={`${BASE_URL}/images/services-og-image.jpg`}
        siteName={SITE_NAME}
        siteNameAr={SITE_NAME_AR}
        structuredData={[servicesPageLD]}
        lang={isArabic ? 'ar' : 'en'}
      />
      
      <Navbar />
      <Services />
      <Footer />
    </>
  );
};

export default ServicesPage;